import React from 'react';
import { FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import * as ShopSelectors from 'selectors/ShopSelectors';
import { useTranslation } from 'services/localization';
import EyeButton from '../../components/EyeButton';
import { useFormContext, Controller } from 'react-hook-form';
import { FormValues } from '../../types';
import { getCustomizerLocaleOnChange } from '../../utils';

const Menu = () => {
	const { t } = useTranslation();
	const { control, watch } = useFormContext<FormValues>();
	const hidden = watch('onlineLayout.footer.about.hidden');

	const defaultLanguage = useSelector(ShopSelectors.activeShopDefaultLanguage);

	return (
		<Stack spacing={1}>
			<Stack direction="row" justifyContent="space-between">
				<Typography
					variant="body2"
					color={hidden ? 'secondary' : 'default'}
					sx={{ textTransform: 'uppercase', fontWeight: 400 }}
				>
					{t('common:menu', 'Menu')}
				</Typography>
				<Controller
					name="onlineLayout.footer.menu"
					control={control}
					render={({ field }) => (
						<EyeButton
							disabled={!field.value?.heading && !field.value?.toggleMenu}
							visible={field.value?.hidden ?? false}
							onChange={(visible) => field.onChange({ ...field.value, hidden: !visible })}
						/>
					)}
				/>
			</Stack>
			<Controller
				name="onlineLayout.footer.menu"
				control={control}
				render={({ field }) => (
					<TextField
						disabled={field.value?.hidden}
						value={field.value?.heading?.def}
						onChange={(event) =>
							field.onChange({
								...field.value,
								heading: getCustomizerLocaleOnChange(
									event.target.value,
									field.value?.heading,
									defaultLanguage,
								),
							})
						}
						label={t('common:form.heading', 'Heading')}
						placeholder={t('common:form.headingPlaceholder', 'Add a heading')}
						InputLabelProps={{
							shrink: true,
						}}
						fullWidth
					/>
				)}
			/>
			<Stack alignItems="flex-start">
				<Controller
					name="onlineLayout.footer.menu"
					control={control}
					render={({ field }) => (
						<FormControlLabel
							disabled={field.value?.hidden}
							control={
								<Switch
									checked={field.value?.toggleMenu ?? false}
									onChange={(e) => field.onChange({ ...field.value, toggleMenu: e.target.checked })}
								/>
							}
							label={t('channels.online.customizer.footer.menu.showMenu', 'Show menu')}
						/>
					)}
				/>
			</Stack>
		</Stack>
	);
};

export default Menu;
